import { render, staticRenderFns } from "./Companies.edit.vue?vue&type=template&id=4267c754&"
import script from "./Companies.edit.vue?vue&type=script&lang=js&"
export * from "./Companies.edit.vue?vue&type=script&lang=js&"
import style0 from "./Companies.edit.vue?vue&type=style&index=0&id=4267c754&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports